const KNOWN_MCP_OAUTH_LAST_ERROR_KEYS: Record<string, string> = {
  'Claude MCP is not connected to this Savvy account. Open Savvy Settings, click Connect Claude MCP, then add the connector in Claude.':
    'mcpOAuth.errorUnboundTokenDescription',
  'Invalid or expired OAuth token': 'mcpOAuth.errorTokenExpiredDescription',
  'Missing required MCP scope': 'mcpOAuth.errorMissingScopeDescription',
};

export const resolveMcpOAuthLastErrorMessage = (
  lastError: string | null,
  t: (key: string) => string,
): string => {
  if (!lastError) {
    return t('mcpOAuth.errorTokenRefreshFailedDescription');
  }

  const knownErrorKey = KNOWN_MCP_OAUTH_LAST_ERROR_KEYS[lastError];
  if (knownErrorKey) {
    return t(knownErrorKey);
  }

  return lastError;
};
